<!-- ./src/components/shared/NumericInput.vue -->
<template>
  <div class="round-corners" :class="{ disabled: disabled }">
    <button @click="decrease()">-</button>
    <input :disabled="disabled" v-model.number="ownValue" @input="onInput" />
    <button @click="increase()">+</button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: 0
    },
    disabled: {
      default: false
    },
    min: {
      default: 0
    },
    max: {
      default: 100
    },
    nochange: {
      default: false
    }
  },
  data() {
    return {
      ownValue: 0
    };
  },
  created() {
    this.ownValue = this.value;
  },
  watch: {
    value: function(newVal) {
      this.ownValue = newVal;
    }
  },
  methods: {
    increase() {
      if (!this.disabled && this.value < this.max) {
        if (!this.nochange) {
          this.value++;
          this.$emit("input", this.value);
        } else {
          this.$emit("input", this.value + 1);
        }
      }
    },
    decrease() {
      if (!this.disabled && this.value > this.min) {
        if (!this.nochange) {
          this.value--;
          this.$emit("input", this.value);
        } else {
          this.$emit("input", this.value - 1);
        }
      }
    },
    onInput() {
      if (
        !this.disabled &&
        this.ownValue >= this.min &&
        this.ownValue <= this.max
      ) {
        this.$emit("input", this.ownValue);
      }
    }
  }
};
</script>

<style scoped>
.round-corners {
  border: 1px solid #cecece;
  border-radius: 50px;
  padding: 0px 7px;
  height: 42px;
  display: inline-flex;
  background-color: white;
}

.round-corners.disabled {
  opacity: 0.5;
}

button {
  border: 0px;
  background: transparent;
  outline: 0;
}

input {
  border: 0px;
  outline: 0;
  text-align: center;
  width: 40px;
  background-color: transparent;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
